// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"b925f7eae72bd504b712","655":"6b1dffd4cb7e4ec180f6"}[chunkId] + ".js";
};